/**
 * CORE-1305 — что мы говорим мастеру, когда записи не будет.
 *
 * До этого тикета недоступность записи была НЕВИДИМОЙ. Флаг `live_recording`
 * (CORE-1043) убирает шаг «Запись» из визарда, кнопку записи из комнаты и
 * автостарт CORE-816 — и на этом всё: мастер узнавал об отсутствии записи по
 * самому отсутствию записи, уже после практики, когда переснять нечего. Ровно
 * это произошло на проде 07.09.2026 (CORE-1304).
 *
 * Снаружи «на этой среде не предлагаем» и «сломалось» выглядят одинаково —
 * в обоих случаях мастер видит пустоту на месте кнопки. Тексты живут здесь,
 * а не по месту использования, потому что мест четыре (обзор веб-визарда,
 * чек-лист нативного, баннер в комнате, отказ старта), и разъехавшиеся
 * формулировки на них читались бы как четыре разные ситуации.
 */

/** Обзор визарда: последнее место, где мастер видит сессию до её создания. */
export const RECORDING_UNAVAILABLE_WIZARD =
    'Запись сейчас недоступна: после сессии записи не останется.';

/** Комната, хосту. Тот же факт, сказанный из настоящего времени. */
export const RECORDING_UNAVAILABLE_ROOM =
    'Запись сейчас недоступна — эта сессия не записывается.';

/**
 * Живой отказ старта. Отдельный текст, потому что здесь мастер уже НАЖАЛ
 * кнопку: общее «Не удалось начать запись» описывало наш неуспех, а не его
 * положение, и не отвечало на единственный вопрос — стоит ли жать ещё раз
 * (не стоит) и продолжать ли сессию (продолжать).
 */
export const RECORDING_NOT_CONFIGURED_MESSAGE =
    'Запись сейчас недоступна — начать её не получится. Сессия идёт как обычно.';

/**
 * Отказ «записи в этой среде нет», отличённый от всех прочих неудач старта.
 *
 * Сервер отвечает 503 с телом `{ code: 'recording_not_configured' }`
 * (`WatchPartyController.StartRecordingInternal` — сервис не зарегистрирован
 * ЛИБО зарегистрирован без ключей). Проверяем оба признака: код — то, ради
 * чего его завели, статус — страховка на случай, когда тело не разобралось
 * (`handleResponse` тогда отдаёт объект без `code`, но со `status`).
 */
export function isRecordingNotConfigured(err: unknown): boolean {
    const e = err as { status?: number; code?: string } | null | undefined;
    if (!e) return false;
    return e.code === 'recording_not_configured' || e.status === 503;
}
